export const LATAM = [
  // Core LATAM
  "AR",
  "BO",
  "BR",
  "CL",
  "CO",
  "CR",
  "CU",
  "DO",
  "EC",
  "SV",
  "GT",
  "HN",
  "MX",
  "NI",
  "PA",
  "PY",
  "PE",
  "PR",
  "UY",
  "VE",
  // Extended Caribbean & Territories
  "BZ",
  "GF",
  "GY",
  "SR",
  "AI",
  "AG",
  "AW",
  "BS",
  "BB",
  "BM",
  "BQ",
  "VG",
  "KY",
  "CW",
  "DM",
  "GD",
  "GP",
  "HT",
  "JM",
  "MQ",
  "MS",
  "BL",
  "KN",
  "LC",
  "MF",
  "PM",
  "VC",
  "SX",
  "TT",
  "TC",
];

const TRIAL_ONLY = new Set(["US", "CA", ...LATAM]);

export function isTrialOnly(cc) {
  if (!cc) return false;
  return TRIAL_ONLY.has(String(cc).toUpperCase());
}

export function getBootstrappedCC() {
  if (typeof window === "undefined") return "";
  // Prefer SSR-injected window var
  var v = (window.__DF_CC || "").toString().toUpperCase();
  if (v) return v;
  // Fallback: cookie
  try {
    var c =
      ("; " + document.cookie).split("; df_cc=").pop().split(";")[0] || "";
    return c.toUpperCase();
  } catch (_) {
    return "";
  }
}
